import { render, staticRenderFns } from "./SuggestBody.vue?vue&type=template&id=6ae4795e&scoped=true&"
import script from "./SuggestBody.vue?vue&type=script&lang=ts&"
export * from "./SuggestBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae4795e",
  null
  
)

export default component.exports